import React, { useRef } from 'react'
import { Link, graphql, useStaticQuery, navigate } from 'gatsby'
import { gsap } from 'gsap-wrapper'
import { useLocation } from '@reach/router'
import { LocaleContext } from 'styles/locale-provider'
import { ThemeContext } from 'styles/theme-provider'
import AnimatedCrossButton from '../animated-cross-btn'

import { List, Li, Item, MainLink } from './index.styled'

const SubmenuList = ({ onStartVideo = false }) => {
  const { lang, getI18Url } = React.useContext(LocaleContext)
  const { scrollSmoother } = React.useContext(ThemeContext)

  const { pathname } = useLocation()
  const [hover, setHover] = React.useState(null)

  const {
    menuContent: { content: links },
  } = useStaticQuery(graphql`
    query SubmenuListQuery {
      menuContent {
        content {
          title
          url
          submenu {
            title
            url
          }
        }
      }
    }
  `)

  const mainUrl =
    pathname.split('/')[1] === lang
      ? pathname.split('/')[2]
      : pathname.split('/')[1]

  const menu =
    mainUrl === 'destination' || mainUrl === ''
      ? links[0]
      : links?.find((item) => item.url === `/${mainUrl}/`)

  /*  console.dir(mainUrl)
  console.dir(links)
  console.dir(menu) */
  const isSecondLevelPage =
    pathname.split('/')[1] === lang
      ? pathname.split('/')[3]
        ? true
        : !!pathname.split('/')[2]
      : !!pathname.split('/')[2]

  const ScrollToDining = () => {
    const targetElement = document.querySelector('#dining-start')
    if (targetElement) {
      gsap.to(scrollSmoother.current, {
        scrollTop: targetElement.offsetTop,
        duration: 2,
      })
    }
  }
  // if (!isSecondLevelPage && !onStartVideo) return null

  const pageTitle =
    mainUrl === 'destination' || mainUrl === '' ? 'Destination' : menu?.title
  return (
    <>
      {!onStartVideo && mainUrl === 'press' && (
        <MainLink to={getI18Url('/press/')} className="main-title-link">
          <span>Press</span>
          <span>Press</span>
        </MainLink>
      )}
      {!onStartVideo && mainUrl !== 'press' && (
        <MainLink to={getI18Url(menu?.url)} className="main-title-link">
          <span>{pageTitle}</span>
          <span>{pageTitle}</span>
        </MainLink>
      )}
      {menu?.submenu && (
        <List className={onStartVideo ? 'atVideo' : 'atHeader'}>
          {/* special down link for dinner page */}
          {mainUrl === 'dining' && onStartVideo ? (
            <Li
              onMouseOver={() => setHover(10)}
              onMouseLeave={() => setHover(null)}
              onClick={ScrollToDining}
            >
              <Item as="span">THE CHEFS</Item>
              <AnimatedCrossButton
                className={[
                  'white down mob-no-anim',
                  hover && hover === 10 && 'hover',
                ].join(' ')}
              />
            </Li>
          ) : null}

          {menu?.submenu?.map((item, i) => (
            <Li
              className={`${pathname}` === getI18Url(item.url) && 'active'}
              key={`submenu-${i}`}
              onMouseOver={() => setHover(i + 1)}
              onMouseLeave={() => setHover(null)}
            >
              <Item to={getI18Url(item.url)}>{item.title}</Item>
              {onStartVideo && (
                <AnimatedCrossButton
                  onClick={() => navigate(getI18Url(item.url))}
                  className={[
                    'white mob-no-anim',
                    hover && hover === i + 1 && 'hover',
                  ].join(' ')}
                />
              )}
            </Li>
          ))}
        </List>
      )}
    </>
  )
}

export default SubmenuList
